import Disclaimer from "components/functional/disclaimer";
import styles from "./empty-team.module.css";
import ranaAlone from "illustrations/rana/rana-alone.webp";
import { useTranslation } from "react-i18next";

const EmptyTeam = ({ handleInvitations }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Disclaimer status="start" />
      <img src={ranaAlone} alt="empty-team" className={styles.image} />
      <div className={styles.description}>
        <h2 className="title-1">{t("teams.empty-state.title")}</h2>
        <p className="title-3-variant">{t("teams.empty-state.description")}</p>
      </div>
      <button className="btn btn--primary" onClick={handleInvitations}>
        {t("teams.empty-state.cta")}
      </button>
    </div>
  );
};

export default EmptyTeam;
